import { saveAs } from 'file-saver';
import { ChoiceGroup, CommandBarButton, ContextualMenu, DefaultButton, Dialog, DialogFooter, DialogType, FontSizes, getId, PrimaryButton, Spinner } from '@fluentui/react';
import React, { useContext, useState } from 'react';
import * as Azure from "@azure/storage-blob";
import { MyContext } from '../../../../../context';
import gql from 'graphql-tag';

export default function MailDownloadDialog({ conversationId, client, authorization }) {
     const context = useContext(MyContext);
     const [subTitle, setSubTitle] = useState('Copy Data');
     const [downloadRunning, setDownloadRunning] = useState(false);
     const [dialogOpen, setDialogOpen] = useState(false);
     const [dlType, setDlType] = useState(undefined);
     const [downloadStatusInfo, setDownloadStatusInfo] = useState('');


     async function downloadBlob(downloadContent) {
          setSubTitle('Copy Data')
          setDownloadRunning(true);
          const result = await callExportMutator("", downloadContent)
          const blobUrl = result.data.downloadBlobWithStatus.downloadUrl;
          const downloadStatus = result.data.downloadBlobWithStatus.downloadStatus;
          const statusInfo = (downloadStatus === "NoAudio") ? context.getTranslation("detailContainer", "audioNotAvailable") : (downloadStatus ? downloadStatus : "");
          if (blobUrl !== "") {
               setSubTitle("Download Zip File");
               const blobContent = await fetchBlobContent(blobUrl)
               setSubTitle("Save Zip File");
               saveAs(blobContent, conversationId + ".zip");
               // Finish (Delete) Export Blob
               await callExportFinishedMutator(blobUrl)
               setSubTitle("Download finished");
               setDownloadStatusInfo(statusInfo);
               setDownloadRunning(false);
               setDialogOpen(false);
          } else {
               setSubTitle(downloadStatus === "NoAudio" ? context.getTranslation("detailContainer", "audioNotAvailable") : (downloadStatus ? downloadStatus : "Download not available"));
               setDownloadRunning(false);
          }
     }

     async function callExportMutator(zipPassword, downloadContent) {
          return await client.mutate({
               mutation: gql`
                     mutation ent ($auth:AuthInput, $conversationId : String!, $audioOnly: Boolean, $zipPassword: String, $mailBody: Boolean,$mailAttachments: Boolean) {
                               downloadBlobWithStatus (input:$auth, conversationId: $conversationId, audioOnly: $audioOnly, zipPassword: $zipPassword, mailBody: $mailBody, mailAttachments: $mailAttachments) {
                                    downloadUrl
                                    downloadStatus
                               }
                           }
                     `,
               variables: {
                    auth: authorization,
                    conversationId: conversationId,
                    zipPassword: zipPassword,
                    audioOnly: false,
                    mailBody: downloadContent.includeBody,
                    mailAttachments: downloadContent.includeAttachemnts
               }
          })
     }

     async function fetchBlobContent(blobUrl) {
          const anonymousCredential = new Azure.AnonymousCredential();
          const pipeline = Azure.StorageURL.newPipeline(anonymousCredential);
          const serviceURL = new Azure.ServiceURL(blobUrl, pipeline);
          const containerURL = Azure.ContainerURL.fromServiceURL(serviceURL, "");
          const blockBlobURL = Azure.BlockBlobURL.fromContainerURL(containerURL, conversationId + ".zip");
          // Download BlockBlob
          const downloadBlockBlobResponse = await blockBlobURL.download();
          return (await downloadBlockBlobResponse.blobBody);
     }

     async function callExportFinishedMutator(blobUrl) {
          return await client.mutate({
               mutation: gql`
                         mutation ent ($conversationId : String!, $url: String!) {
                              downloadFinished (conversationId: $conversationId, url: $url)
                         }
                         `,
               variables: { conversationId: conversationId, url: blobUrl }
          });
     }

     const dlOptions = [
          {
               key: 'all',
               text: context.getTranslation("detailContainer","mailExportAll"),
          },
          {
               key: 'body',
               text: context.getTranslation("detailContainer","mailExportBodyAndMeta"),
          },
          {
               key: 'attachments',
               text: context.getTranslation("detailContainer","mailExportAttachmentsAndMeta"),
          },
          {
               key: 'metadata',
               text: context.getTranslation("detailContainer","mailExportOnlyMeta"),
          },
     ]

     function mapSelectionToContent(selection) {
          return {
               includeBody: selection === "all" || selection === "body",
               includeAttachemnts: selection === "all" || selection === "attachments"
          }
     }

     return <div>
          <CommandBarButton
               iconProps={{ iconName: 'Download' }}
               style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.Icon, width: "100%", textAlign: "left" }}
               onClick={() => setDialogOpen(true)}
               text={context.getTranslation("detailContainer", window.innerWidth < 600 ? "exp" : "exportButton")}
          />

          <Dialog
               hidden={!dialogOpen}
               onDismiss={() => { setDialogOpen(false); setDownloadStatusInfo(''); }}
               dialogContentProps={{
                    type: DialogType.normal,
                    title: context.getTranslation("detailContainer", "exportDialogTitle"),
                    closeButtonAriaLabel: 'Close',
                    subText: subTitle,
               }}
               modalProps={{
                    titleAriaId: getId('dialogLabel'),
                    subtitleAriaId: getId('subTextLabel'),
                    isBlocking: false,
                    styles: { main: { maxWidth: 450 } },
                    dragOptions: {
                         moveMenuItemText: 'Move',
                         closeMenuItemText: 'Close',
                         menu: ContextualMenu,
                    },
               }}
          >
               {downloadRunning && <Spinner />}
               {downloadStatusInfo && <span style={{ display: 'block', fontSize: '14px', marginTop: '-12px' }}>{downloadStatusInfo}</span>}
               <ChoiceGroup
                    selectedKey={dlType}
                    options={dlOptions}
                    onChange={(event, newValue) => setDlType(newValue.key)}
               />

               <DialogFooter>
                    <PrimaryButton
                         disabled={dlType === undefined}
                         onClick={() => downloadBlob(mapSelectionToContent(dlType))}
                         text={context.getTranslation('detailContainer', 'exportstart')}
                    />
                    <DefaultButton
                         onClick={() => setDialogOpen(false)}
                         text={context.getTranslation("common", "close")}
                    />
               </DialogFooter>
          </Dialog>
     </div>
}

